import { useState } from "react";
import { useContextContrato } from "src/Contexts/Lancamentos/Contrato/ContratosContext";
import { valueDefaultInputContratos } from "src/Contexts/Lancamentos/Contrato/valuesDefaultInputsContratos/ValueDefaultInputContratos";

import { GetDateUSSemValue } from "src/shared/Utils/FormatDateBR";
import { FormatMoney } from "src/shared/Utils/FormatMoney";
import { formatString } from "@format-string/core";
import axios from "axios";
import { cpfOurCnpj } from "src/shared/Utils/MaskCpfCnpj";
import { FormatRG } from "src/shared/Utils/FormatRG/FormatRG";
import { handleFormatCep } from "src/shared/Utils/FormatCEP";
import {
  Box,
  alpha,
  Tooltip,
  useMediaQuery,
  CircularProgress,
} from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { ButtonCore } from "src/Pages/components/ButtonCore/ButtonCore";
import { useAppThemeContext } from "src/Contexts/ThemeContextConfig";
import {
  DropZoneCore,
  IListPDF,
} from "src/Pages/components/DropZoneCore/DropZoneCore";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { api } from "src/shared/setup/API/api";
import { useAuthContext } from "src/Contexts/AuthContext/authContext";
import { ICompany, IUsers } from "src/Contexts/AuthContext/AuthContextTypes";

export const FormatDateUS = (value: string) => {
  const [dia, mes, ano] = value.split("/");
  const montDate = `${ano}-${mes}-${dia}`;
  return montDate;
};

export const UploadWithIAContract = () => {
  const { userPerfil, setUserPerfil } = useAuthContext();
  const { setValuesInputsContrato } = useContextContrato();
  const { themeName } = useAppThemeContext();
  const { handleGetAlert } = useLayoutMainContext();

  const [loading, setLoading] = useState(false);
  const isMobile = useMediaQuery("(max-width: 600px)");

  const handleUpdateAvatar = (files: IListPDF[]) => {
    const formData = new FormData();

    const blob = new Blob([files[0].pdf], { type: files[0].type });
    formData.append("file", blob, files[0].name);

    const objGenero = {
      feminino: "feminino",
      masculino: "masculino",
      outro: "outros",
      nao_informado: "",
    } as const;

    const objEstadoCivil = {
      solteiro: "solteiro",
      casado: "casado",
      separado: "separado",
      divorciado: "divorciado",
      viuvo: "viuvo",
      nao_informado: "",
    } as const;

    if (userPerfil?.empresa.creditIA.countRemaining === 0) {
      handleGetAlert({ message: "Você não possui créditos suficientes" });
      return;
    }

    setLoading(true);

    return axios
      .post(
        `https://ia-leitura-pdf-contrato-production.up.railway.app`,
        // `http://localhost:3333`,
        formData
      )
      .then(({ data: { data } }) => {
        setValuesInputsContrato(valueDefaultInputContratos);
        setValuesInputsContrato({
          ...valueDefaultInputContratos,

          assinatura_data: FormatDateUS(
            data.contrato?.data_assinatura?.trim() ?? `${GetDateUSSemValue()}`
          ),

          cod_proposta: data.contrato?.proposta,

          tipo_contrato: data.contrato?.tipo_pessoa ?? "PF",

          titular_pf: data.titular?.nome_titular?.trim() ?? "",
          mae_pf: data.titular?.nome_mae_titular?.trim() ?? "",

          estado_civil_pf: data.contrato?.tipo_pessoa === "PF"
            ? objEstadoCivil[data.titular?.estado_civil_titular?.trim().toLowerCase() as keyof typeof objEstadoCivil ?? ""]
            : "",

          genero_pf:
            data.contrato?.tipo_pessoa === "PF"
              ? objGenero[(data.titular?.genero_titular?.trim().toLowerCase() as keyof typeof objGenero) ?? ""]
              : "",

          rg_pf: FormatRG(data.titular?.rg_titular ?? ""),

          cpf_cnpj: cpfOurCnpj({
            text: data.contrato?.tipo_pessoa === "PF"
              ? data.titular?.cpf_titular || ""
              : data.titular?.cnpj || "",
            type: data.contrato?.tipo_pessoa === "PF" ? "cpf" : "cnpj",
          }),

          razao_social_pj: data.titular?.nome_titular?.trim() ?? "",

          email: data?.endereco_contato?.email,
          telefone_1:
            formatString({
              type: "phone",
              value: data?.endereco_contato?.telefone_1 ?? "",
            }) || "",
          telefone_2:
            formatString({
              type: "phone",
              value: data?.endereco_contato?.telefone_2 ?? "",
            }) || "",

          cep: handleFormatCep(data?.endereco_contato?.cep?.trim() ?? ""),
          endereco_numero: data?.endereco_contato?.numero?.trim() ?? "",
          cidade: data?.endereco_contato?.cidade?.trim() ?? "",
          bairro: data?.endereco_contato?.bairro?.trim() ?? "",
          uf: data?.endereco_contato?.uf?.trim() ?? "",
          endereco: data?.endereco_contato?.endereco?.trim() ?? "",
          complemento: data?.endereco_contato?.complemento?.trim() ?? "",

          vigencia_data:
            data?.dados?.data_vigencia ? FormatDateUS(data?.dados?.data_vigencia?.trim() ?? "") :
              `${GetDateUSSemValue()}`,
          emissao_data:
            data?.dados?.data_emissao ? FormatDateUS(data?.dados?.data_emissao?.trim() ?? "") :
              `${GetDateUSSemValue()}`,


          mensalidade_value: FormatMoney(data.dados?.mensalidade),
        });
        setUserPerfil((prev) => ({
          ...(prev as IUsers),
          empresa: {
            ...(prev?.empresa as ICompany),
            creditIA: {
              ...(prev?.empresa.creditIA as ICompany["creditIA"]),
              countRemaining: (prev?.empresa?.creditIA.countRemaining ?? 0) - 1,
            },
          },
        }));

        api.post("/company/update-use-ia");
      })
      .catch((error) => {
        console.log(error);
        handleGetAlert({
          message:
            error?.response?.data?.message || "não foi possível ler o pdf",
        });
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          mb: "12px",
          justifyContent: "space-between",
          position: "relative",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "160px",
            right: "0px",
            height: "2px",
            background: (theme) =>
              `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
            transform: "translateY(-50%)",
            zIndex: 0,
            mr: "4px",
          }}
        />
        <DropZoneCore
          onFilesChange={loading ? undefined : handleUpdateAvatar}
          multiple={false}
          accept={{ "application/pdf": [] }}
          disabled={
            loading || userPerfil?.empresa.creditIA.countRemaining === 0
          }
          sxStyle={{ display: "inline-block", position: "relative", zIndex: 1 }}
        >
          <Tooltip
            title={
              userPerfil?.empresa.creditIA.countRemaining === 0
                ? "Você não possui créditos suficientes"
                : "Selecione uma proposta em PDF para importar dados automaticamente com IA"
            }
          >
            <ButtonCore
              sx={{
                position: "relative",
                zIndex: 1,
                fontWeight: "bold",
                fontSize: "12px",
                cursor: loading ? "default" : "pointer",
                color: (theme) => theme.palette.text.primary,
                borderRadius: "10px",
                padding: "10px 20px",
                background: themeName === "dark" ? "#2d2f36" : "#fff",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  zIndex: -1,
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  borderRadius: "inherit",
                  padding: "2px",
                  background:
                    "linear-gradient(145deg, #00f57b,  #9c27b0, #f50057)",
                  WebkitMask:
                    "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                  WebkitMaskComposite: "xor",
                  maskComposite: "exclude",
                },
                "&:hover": {
                  background: (theme) =>
                    themeName === "dark"
                      ? "#3c3f49"
                      : alpha(theme.palette.background.paper, 0.9),
                },
              }}
              title={
                isMobile
                  ? "Importar com IA"
                  : `Importar dados com IA (Créditos: ${userPerfil?.empresa.creditIA.countRemaining})`
              }
              endIcon={
                loading ? (
                  <CircularProgress size={14} />
                ) : (
                  <AutoAwesomeIcon style={{ fontSize: "16px" }} />
                )
              }
            />
          </Tooltip>
        </DropZoneCore>
      </Box>
    </>
  );
};
